import { motion } from "motion/react";
import styled from "styled-components";

export const ATWrapper = styled(motion.div)`
  position: fixed;
  pointer-events: auto;
  z-index: 9999999;
  /*  transition: all 0.14s; */
`;
